import React from 'react';
import { Routes, Route, Link, useNavigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import EventList from './components/EventList';
import EventDetails from './components/EventDetails';
import Login from './components/Login';
import Register from './components/Register';
import Profile from './components/Profile';

function App() {
  const { user, logout, loading } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  if (loading) return <div className="container"><p>Loading...</p></div>;

  return (
    <div>
      <nav>
        <Link to="/" className="nav-brand">Event<span>Hub</span></Link>
        <div className="nav-links">
          <Link to="/">Events</Link>
          {user ? (
            <>
              <Link to="/profile">My Bookings</Link>
              <div className="nav-user">
                <span>Hi, {user.name?.split(' ')[0]}</span>
                <button onClick={handleLogout} className="btn btn-outline btn-sm">Logout</button>
              </div>
            </>
          ) : (
            <>
              <Link to="/login">Login</Link>
              <Link to="/register" className="btn btn-outline btn-sm">Sign Up</Link>
            </>
          )}
        </div>
      </nav>
      <div className="container">
        <Routes>
          <Route path="/" element={<EventList />} />
          <Route path="/event/:id" element={<EventDetails />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/profile" element={<Profile />} />
        </Routes>
      </div>
    </div>
  );
}

export default App;
